<template>
  <router-view />
</template>


<script>
export default {
  methods: {
    checkUserAccess() {
      if (this.$helpers.getAccessToken()) {
        this.$api({
          url: 'Dashboard',
          method: 'get'
        }).catch(err => {
          this.isLoading.recordSection.plant = false
          this.isLoading.recordSection.external = false
          this.isLoading.recordSection.place = false
          if (err.response.status == 401) {
            this.$store.dispatch('auth/logout')
            this.$router.push('/login')
          }
        })
      }
    }
  },
  mounted() {
    // this.checkUserAccess()
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
